const messages = {
  en: {
    issue: 'Select issue'
  },
  'es-ud': {
    issue: 'Seleccionar problema'
  },
  es: {
    issue: 'Seleccionar problema'
  }
}

export default messages



// WEBPACK FOOTER //
// ./src/containers/Guides/messages.js